import { ToastrService } from 'ngx-toastr';
import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { EChartsOption } from 'echarts';
import * as echarts from 'echarts';
import 'echarts-wordcloud';
import { SegmentacaoService } from '../../../services/segmentacao.service';
import { TipoFiltro } from '../../../enums/tipo-filtro.enum';
import {
  ChaveValor,
  ChaveValorUF,
  CheckboxChaveValor,
} from '../../../interfaces/segmentacao/chave-valor.interface';
import {
  FiltroSegmentacao,
  FiltroSegmentacaoIdade,
} from '../../../interfaces/segmentacao/filtro-segmentacao.interface';
import { debounceTime, distinctUntilChanged, Subject } from 'rxjs';
import { StringUtil } from '../../../infra/string-util';
import { TipoGrafico } from '../../../enums/tipo-grafico.enum';
import { DadosGrafico } from '../../../interfaces/segmentacao/dados-grafico.interface';
import { RetornoSegmentacao } from '../../../interfaces/segmentacao/retorno-segmentacao.interface';
import { Contadores } from '../../../interfaces/segmentacao/contadores.interface';
import { FiltroSegmentacaoService } from '../../../state-service/filtro-segmentacao.service';
import { PermissaoService } from '../../../services/permissao.service';
import { EnumPermissao } from '../../../enums/permissoes.enum';
import { ListasService } from '../../../services/listas.service';
import { ResponsePreGravacao } from '../../../interfaces/lista-contato/lista-contato.interface';

declare var bootstrap: any;

const eChartsGlobalConfig = {
  color: [
    '#00D59A',
    '#3A7DE8',
    '#93a1c1',
    '#FFAF26',
    '#FF6565',
    '#6456BB',
    '#68C7AC',
    '#71A5D5',
    '#e2db46',
    '#FFC27D',
    '#FF8E8E',
    '#8E77D4',
    '#9BD9C4',
    '#8CB3E6',
    '#E8E8F4',
    '#FFD885',
    '#FF9999',
    '#A793D0',
    '#ACDFD0',
    '#A4C8EA',
    '#ECECF8',
    '#FFDCB3',
    '#FFB8B8',
    '#AE9EDA',
    '#BBE9DE',
    '#B3D0F0',
    '#F7F7FD',
    '#FFE5BF',
    '#FFC9C9',
    '#C7B2E4',
  ],
};

const labelTextConfigs = {
  color: '#000',
};

echarts.registerPreprocessor((option: any) => {
  option.color = eChartsGlobalConfig.color;
});

@Component({
  selector: 'app-segmentacao',
  standalone: false,
  templateUrl: './segmentacao.component.html',
  styleUrl: './segmentacao.component.css',
})
export class SegmentacaoComponent implements OnInit {
  constructor(
    private segmentacaoService: SegmentacaoService,
    private cdr: ChangeDetectorRef,
    private toastr: ToastrService,
    private filtroSegmentacaoService: FiltroSegmentacaoService,
    public permissaoService: PermissaoService,
    private listasService: ListasService
  ) {}
  EnumPermissao = EnumPermissao;

  filtroEmEdicao: number = 0;
  mostrarPainelLateral: boolean = false;

  situacaoDocumentosOptions: EChartsOption = {};
  flagsTelefoniaOptions: EChartsOption = {};
  personasPorGeracaoOptions: EChartsOption = {};
  nuvemPalavrasOptions: EChartsOption = {};
  scoreOptions: EChartsOption = {};
  faixaSalarialOptions: EChartsOption = {};
  personaDigitalOptions: EChartsOption = {};

  segmentacaoAtual: number = 0;
  mostrarCreditosFaltantes: boolean = false;
  mostrarSaldoCreditos: boolean = true;

  optUfs: CheckboxChaveValor[] = [];
  optUfsSelecionadas: ChaveValor[] = [];
  optCidades: ChaveValorUF[] = [];
  optCidadesSelecionadas: ChaveValorUF[] = [];
  optTipoContato: ChaveValor[] = [];

  loadingUfs: boolean = false;
  loadingCidades: boolean = false;
  loadingTelefones: boolean = false;
  loadingOportunidades: boolean = false;
  loadingEmails: boolean = false;
  loadingSituacaoDocumentos: boolean = false;
  loadingPersonasPorGeracao: boolean = false;
  loadingScore: boolean = false;
  loadingPersonaDigital: boolean = false;
  loadingFlagsTelefonia: boolean = false;
  loadingFaixaSalarial: boolean = false;
  loadingNuvemPalavras: boolean = false;

  contadores: Contadores = {
    oportunidadesNumber: 0,
    oportunidades: '0',
    telefones: '0',
    emails: '0',
  };

  private dadosSegmentacao: RetornoSegmentacao[] = [];

  pesquisaCidadesUF$ = new Subject<string>();

  filtrosSegmentacao: FiltroSegmentacao = {};
  preGravacaoResponse: ResponsePreGravacao | undefined = undefined;
  qtdRegistrosDisponiveis: number = 0;
  verificandoListaExistente: boolean = false;
  continuarExtracaoContatos: boolean = false;

  filtroIdade: FiltroSegmentacaoIdade = {
    de: undefined,
    ate: undefined,
  };

  ngOnInit() {
    this.filtrosSegmentacao = this.filtroSegmentacaoService.obterFiltroAtual();
    try {
      this.buscarSegmentacao();
    } catch (e) {
      this.toastr.error('Erro ao processar filtro da novidade');
    }

    window.addEventListener('resize', this.recriarGraficos.bind(this));

    this.pesquisaCidadesUF$
      .pipe(debounceTime(300), distinctUntilChanged())
      .subscribe(async (termo) => {
        await this.buscarFiltroCidades(termo);
      });
  }

  ngOnDestroy() {
    window.removeEventListener('resize', this.recriarGraficos.bind(this));
    this.filtroSegmentacaoService.resetarFiltro();
    this.filtrosSegmentacao = JSON.parse(
      JSON.stringify(this.filtroSegmentacaoService.obterFiltroAtual())
    );
  }

  getValoresExibirSegmentacao(tipoFiltro: TipoFiltro): string[] {
    switch (tipoFiltro) {
      case TipoFiltro.UF:
        return (
          this.filtrosSegmentacao.cidades?.map((cidade) =>
            cidade.cidade
              ? cidade.uf + ': ' + cidade.cidade
              : cidade.uf + ': Todas as cidades'
          ) ?? []
        );
      case TipoFiltro.TipoContato:
        return (
          this.filtrosSegmentacao.contatos?.map((tipo) => tipo.valor) ?? []
        );
      case TipoFiltro.Idade:
        let retorno = [];
        if (this.filtrosSegmentacao.idade?.de !== undefined) {
          retorno.push(`De: ${this.filtrosSegmentacao.idade.de}`);
        }
        if (this.filtrosSegmentacao.idade?.ate !== undefined) {
          retorno.push(`Até: ${this.filtrosSegmentacao.idade.ate}`);
        }
        return retorno;
      default:
        return [];
    }
  }

  converterStringArrayToChaveValor(array?: string[]): ChaveValor[] {
    return array?.map((item) => ({ chave: item, valor: item })) ?? [];
  }

  onSegmentacaoChange(event: any) {
    this.segmentacaoAtual = Number(event.target.value);

    if (this.segmentacaoAtual === TipoFiltro.UF) {
      this.obterFiltroSegmentacaoUfs(this.segmentacaoAtual);
    } else if (this.segmentacaoAtual === TipoFiltro.Idade) {
      this.filtroIdade = {
        de: this.filtrosSegmentacao.idade?.de,
        ate: this.filtrosSegmentacao.idade?.ate,
      };
    }
  }

  adicionarUf(selecionado: ChaveValor) {
    if (!selecionado) return;

    if (!this.optUfsSelecionadas.some((uf) => uf.chave === selecionado.chave)) {
      this.optUfsSelecionadas.push(selecionado);
      if (
        !this.optCidadesSelecionadas.some(
          (cidade) => cidade.uf === selecionado.chave
        )
      ) {
        this.optCidadesSelecionadas = [
          { chave: selecionado.chave, valor: '', uf: selecionado.chave },
          ...this.optCidadesSelecionadas,
        ];
      }
    } else {
      this.optUfsSelecionadas = this.optUfsSelecionadas.filter(
        (uf) => uf.chave !== selecionado.chave
      );
      this.optCidadesSelecionadas = this.optCidadesSelecionadas.filter(
        (cidade) => cidade.uf !== selecionado.chave
      );
    }

    this.atualizarListaFiltros(TipoFiltro.Cidade, []);
  }

  async buscarFiltroCidades(termoPesquisa: string = ''): Promise<void> {
    this.loadingCidades = true;
    const ufsSelecionadas = this.optUfsSelecionadas
      .map((uf) => uf.chave)
      .join(',');
    const data = await this.segmentacaoService.buscarFiltroCidades({
      tipo: TipoFiltro.Cidade,
      filtro: termoPesquisa,
      ufs: ufsSelecionadas ? ufsSelecionadas : '',
    });
    this.atualizarListaFiltros(TipoFiltro.Cidade, data);
    this.loadingCidades = false;
  }

  adicionarRemoverCidade(cidade: ChaveValorUF): void {
    if (!cidade) return;

    const cidadeJaSelecionada = this.isCidadeSelecionada(cidade);

    if (cidadeJaSelecionada) {
      this.removerCidade(cidade);
    } else {
      this.adicionarCidade(cidade);
    }

    this.cdr.detectChanges();
  }

  private isCidadeSelecionada(cidade: ChaveValorUF): boolean {
    return this.optCidadesSelecionadas.some(
      (x) => x.chave === cidade.chave && x.valor == cidade.valor
    );
  }

  private adicionarCidade(cidade: ChaveValorUF): void {
    this.optCidadesSelecionadas = this.optCidadesSelecionadas.filter(
      (x) => !(x.uf === cidade.uf && x.valor === '')
    );

    if (
      !this.optCidadesSelecionadas.some(
        (x) => x.chave === cidade.chave && x.valor == cidade.valor
      )
    ) {
      this.optCidadesSelecionadas = [...this.optCidadesSelecionadas, cidade];
    }

    this.cdr.detectChanges();
  }

  private removerCidade(cidade: ChaveValorUF): void {
    this.optCidadesSelecionadas = this.optCidadesSelecionadas.filter(
      (x) => x.valor !== cidade.valor
    );

    if (
      this.optUfsSelecionadas.some((x) => x.chave === cidade.uf) &&
      !this.optCidadesSelecionadas.some((x) => x.uf === cidade.uf)
    ) {
      this.optCidadesSelecionadas = [
        ...this.optCidadesSelecionadas,
        {
          uf: cidade.uf,
          chave: cidade.uf,
          valor: '',
        },
      ];
    }

    this.cdr.detectChanges();
  }

  async obterFiltroSegmentacaoUfs(tipoFiltro: TipoFiltro): Promise<void> {
    this.loadingUfs = true;
    const data = await this.segmentacaoService.listarFiltro({
      tipo: tipoFiltro,
    });
    this.atualizarListaFiltros(tipoFiltro, data);
    this.loadingUfs = false;
  }

  atualizarListaFiltros(tipoFiltro: TipoFiltro, data: any) {
    switch (tipoFiltro) {
      case TipoFiltro.UF:
        this.optUfs = data.map((item: CheckboxChaveValor) => ({
          chave: item.chave,
          valor: item.valor,
          checked:
            this.filtrosSegmentacao.cidades?.some((x) => x.uf === item.chave) ??
            false,
        }));

        const todasUfs = this.filtrosSegmentacao.cidades
          ? Array.from(
              new Set(this.filtrosSegmentacao.cidades.map((c) => c.uf))
            ).map((uf) => ({ chave: uf, valor: uf }))
          : [];
        this.optUfsSelecionadas = todasUfs;

        this.optCidadesSelecionadas = [
          ...(this.filtrosSegmentacao.cidades?.map((x) => ({
            chave: x.uf,
            valor: x.cidade === '' ? '' : x.uf + ': ' + x.cidade,
            uf: x.uf,
          })) ?? []),
        ];

        break;
      case TipoFiltro.Cidade:
        this.optCidades = data.map((item: ChaveValorUF) => ({
          chave: item.chave,
          valor: `${item.uf}: ${item.valor}`,
          uf: item.uf,
        }));
        break;
    }
  }

  atualizarSegmentacaoIdade(idadeDe: string, idadeAte: string) {
    let de = parseInt(idadeDe, 10);
    let ate = parseInt(idadeAte, 10);

    if(isNaN(de)) {
      de = 18;
    } 

    if(isNaN(ate)) {
      ate = 100;
    } 

    this.filtrosSegmentacao.idade = {
      de: de,
      ate: ate
    };

    this.atualizarSegmentacao([]);
  }

  atualizarSegmentacao(itensSelecionados: ChaveValor[]) {
    let tipoFiltro = this.mostrarPainelLateral
      ? this.filtroEmEdicao
      : this.segmentacaoAtual;
    switch (tipoFiltro) {
      case TipoFiltro.Secretaria:
        if (itensSelecionados.length > 0) {
          this.filtrosSegmentacao.secretarias = itensSelecionados.map(
            (s) => s.chave
          );
        } else {
          this.filtrosSegmentacao.secretarias = undefined;
        }
        break;
      case TipoFiltro.Regime:
        if (itensSelecionados.length > 0) {
          this.filtrosSegmentacao.regimes = itensSelecionados.map(
            (s) => s.chave
          );
        } else {
          this.filtrosSegmentacao.regimes = undefined;
        }
        break;
      case TipoFiltro.Cargo:
        if (itensSelecionados.length > 0) {
          this.filtrosSegmentacao.cargos = itensSelecionados.map(
            (s) => s.chave
          );
        } else {
          this.filtrosSegmentacao.cargos = undefined;
        }
        break;
      case TipoFiltro.PersonaCredito:
        if (itensSelecionados.length > 0) {
          this.filtrosSegmentacao.personaCredito = itensSelecionados.map(
            (s) => s.chave
          );
        } else {
          this.filtrosSegmentacao.personaCredito = undefined;
        }
        break;
      case TipoFiltro.TipoContato:
        this.optTipoContato = itensSelecionados;
        this.filtrosSegmentacao.contatos = itensSelecionados;
        break;
      case TipoFiltro.FaixaSalarial:
        if (itensSelecionados.length > 0) {
          this.filtrosSegmentacao.faixasSalariais = itensSelecionados.map(
            (s) => s.chave
          );
        } else {
          this.filtrosSegmentacao.faixasSalariais = undefined;
        }
        break;
      case TipoFiltro.UF:
        let ufsSemCidades = this.optUfsSelecionadas.filter(
          (uf) =>
            !this.optCidadesSelecionadas.some(
              (cidade) => cidade.uf === uf.chave
            )
        );
        if (
          ufsSemCidades.length > 0 ||
          this.optCidadesSelecionadas.length > 0
        ) {
          this.filtrosSegmentacao.cidades = [
            ...ufsSemCidades.map((uf) => ({ uf: uf.chave, cidade: '' })),
            ...this.optCidadesSelecionadas.map((s) => ({
              uf: s.uf,
              cidade: s.valor.substring(3),
            })),
          ];
        } else {
          this.filtrosSegmentacao.cidades = undefined;
        }
        break;
      case TipoFiltro.Abrangencia:
        this.filtrosSegmentacao.abrangencia = itensSelecionados.map(
          (s) => s.chave
        );
        break;
      case TipoFiltro.Idade:
        let idadeMinima: number | undefined = undefined;
        let idadeMaxima: number | undefined = undefined;

        if (this.filtroIdade.de !== undefined) {
          idadeMinima = Math.max(18, Math.min(120, this.filtroIdade.de));
        }

        if (this.filtroIdade.ate !== undefined) {
          idadeMaxima = Math.max(18, Math.min(120, this.filtroIdade.ate));
        }
        
        if (idadeMinima !== undefined || idadeMaxima !== undefined) {
          if(!this.ValidarValorIdade(idadeMinima, idadeMaxima)){
            return;
          }

          this.filtrosSegmentacao.idade = {
            de: idadeMinima,
            ate: idadeMaxima,
          };
        } else {
          this.filtrosSegmentacao.idade = undefined;
        }

        this.filtroIdade = { de: undefined, ate: undefined };
        break;
      default:
        break;
    }

    this.filtroSegmentacaoService.atualizarFiltro(this.filtrosSegmentacao);
    this.exibirInicioSegmentacao();
    this.buscarSegmentacao();
  }

  abrirEdicaoFiltro(tipoFiltro: number): void {
    this.filtroEmEdicao = tipoFiltro;
    this.mostrarPainelLateral = true;

    document.body.classList.add('painel-lateral-flutuante');

    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 310);

    if (tipoFiltro === TipoFiltro.UF) {
      this.obterFiltroSegmentacaoUfs(tipoFiltro);
    } else if ((tipoFiltro = TipoFiltro.Idade)) {
      this.filtroIdade = {
        de: this.filtrosSegmentacao.idade?.de,
        ate: this.filtrosSegmentacao.idade?.ate,
      };
    }
  }

  fecharPainelLateral(): void {
    this.filtroEmEdicao = 0;
    this.mostrarPainelLateral = false;

    document.body.classList.remove('painel-lateral-flutuante');

    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 310);
  }

  confirmarFiltroLateralIdade(idadeDe: string , idadeAte: string): void {
    this.atualizarSegmentacaoIdade(idadeDe, idadeAte);
    this.fecharPainelLateral();
  }

  confirmarFiltroLateral(itensSelecionados: ChaveValor[]): void {
    this.atualizarSegmentacao(itensSelecionados);
    this.fecharPainelLateral();
  }

  exibirInicioSegmentacao() {
    this.segmentacaoAtual = 0;
  }

  private getChartColors(index: number): string {
    return eChartsGlobalConfig.color[index % eChartsGlobalConfig.color.length];
  }

  buscarSegmentacao(tipos?: TipoGrafico[]) {
    this.loadingTelefones = true;
    this.loadingOportunidades = true;
    this.loadingEmails = true;
    this.loadingSituacaoDocumentos = true;
    this.loadingPersonasPorGeracao = true;
    this.loadingScore = true;
    this.loadingPersonaDigital = true;
    this.loadingFlagsTelefonia = true;
    this.loadingFaixaSalarial = true;
    this.loadingNuvemPalavras = true;
    this.filtrosSegmentacao = this.filtroSegmentacaoService.obterFiltroAtual();

    if (tipos) {
      this.filtrosSegmentacao.tiposRetorno = tipos;
    }

    this.segmentacaoService
      .buscarSegmentacao(this.filtrosSegmentacao)
      .then((data) => {
        this.dadosSegmentacao = data.dados;

        if (
          this.filtrosSegmentacao.tiposRetorno?.includes(
            TipoGrafico.Oportunidades
          ) ||
          this.filtrosSegmentacao.tiposRetorno?.includes(
            TipoGrafico.Telefones
          ) ||
          this.filtrosSegmentacao.tiposRetorno?.includes(TipoGrafico.Emails)
        ) {
          this.contadores = {
            oportunidadesNumber:
              this.getDetalhes(TipoGrafico.Oportunidades, data.dados)[0]
                ?.quantidade ?? 0,
            oportunidades: StringUtil.formatarNumeroTextoNatural(
              this.getDetalhes(TipoGrafico.Oportunidades, data.dados)[0]
                ?.quantidade ?? 0
            ),
            telefones: StringUtil.formatarNumeroTextoNatural(
              this.getDetalhes(TipoGrafico.Telefones, data.dados)[0]
                ?.quantidade ?? 0
            ),
            emails: StringUtil.formatarNumeroTextoNatural(
              this.getDetalhes(TipoGrafico.Emails, data.dados)[0]?.quantidade ??
                0
            ),
          };

          this.qtdRegistrosDisponiveis = this.contadores.oportunidadesNumber;
        }

        if (
          this.filtrosSegmentacao.tiposRetorno?.includes(
            TipoGrafico.SituacaoCPF
          )
        ) {
          this.initChartSituacaoDocumentos(
            this.getDetalhes(TipoGrafico.SituacaoCPF, data.dados)
          );
        }

        if (
          this.filtrosSegmentacao.tiposRetorno?.includes(
            TipoGrafico.FlagsTelefonia
          )
        ) {
          this.initChartTelefonia(
            this.getDetalhes(TipoGrafico.FlagsTelefonia, data.dados)
          );
        }

        if (
          this.filtrosSegmentacao.tiposRetorno?.includes(
            TipoGrafico.PersonaGeracao
          )
        ) {
          this.initChartPersonasPorGeracao(
            this.getDetalhes(TipoGrafico.PersonaGeracao, data.dados)
          );
        }

        if (
          this.filtrosSegmentacao.tiposRetorno?.includes(TipoGrafico.Palavras)
        ) {
          this.initChartNuvemPalavras(
            this.getDetalhes(TipoGrafico.Palavras, data.dados)
          );
        }

        if (this.filtrosSegmentacao.tiposRetorno?.includes(TipoGrafico.Score)) {
          this.initChartScore(this.getDetalhes(TipoGrafico.Score, data.dados));
        }

        if (
          this.filtrosSegmentacao.tiposRetorno?.includes(
            TipoGrafico.FaixaSalarial
          )
        ) {
          this.initChartFaixaSalarial(
            this.getDetalhes(TipoGrafico.FaixaSalarial, data.dados)
          );
        }

        if (
          this.filtrosSegmentacao.tiposRetorno?.includes(
            TipoGrafico.PersonaDigital
          )
        ) {
          this.initChartPersonaDigital(
            this.getDetalhes(TipoGrafico.PersonaDigital, data.dados)
          );
        }

        this.loadingTelefones = false;
        this.loadingOportunidades = false;
        this.loadingEmails = false;
        this.loadingSituacaoDocumentos = false;
        this.loadingPersonasPorGeracao = false;
        this.loadingScore = false;
        this.loadingPersonaDigital = false;
        this.loadingFlagsTelefonia = false;
        this.loadingFaixaSalarial = false;
        this.loadingNuvemPalavras = false;
      });
  }
  private getDetalhes(
    tipo: TipoGrafico,
    data?: RetornoSegmentacao[]
  ): DadosGrafico[] {
    let detalhes = data?.find((f: RetornoSegmentacao) => f.tipo === tipo)
      ?.detalhes ?? [
      { descricao: 'Nenhum dado encontrado', quantidade: 0 } as DadosGrafico,
    ];
    if (detalhes.length == 0) {
      detalhes = [
        { descricao: 'Nenhum dado encontrado', quantidade: 0 } as DadosGrafico,
      ];
    }
    return detalhes;
  }
  private initChartSituacaoDocumentos(itens: DadosGrafico[]) {
    const series = itens.map((item) => ({
      name: item.descricao,
      data: item.quantidade,
    }));

    const somaDataSituacaoDocumento = series.reduce(
      (acc, item) => acc + item.data,
      0
    );

    const seriesComPercentual = series.map((item) => ({
      name: item.name,
      type: 'bar' as const,
      stack: 'total',
      data: [((item.data / somaDataSituacaoDocumento) * 100).toFixed(1)],
      valorAbsoluto: item.data,
    }));

    this.situacaoDocumentosOptions = {
      label: {
        show: true,
        rotate: 90,
        formatter: (params: any) => {
          const percentual = Number(params.value);
          return `${percentual}%`;
        },
        textStyle: labelTextConfigs,
      },
      tooltip: {
        trigger: 'item',
        formatter: (params: any) => {
          const valorTotal =
            seriesComPercentual[params.componentIndex].valorAbsoluto;
          return `<b>Quantidade</b>: ${StringUtil.formatarNumeroMilharesCentenas(
            valorTotal
          )} `;
        },
      },
      legend: {
        orient: 'horizontal',
        left: 'center',
        right: 'auto',
        top: 190,
      },

      grid: {
        top: '5%',
        left: '5%',
        right: '5%',
        bottom: '25%',
        containLabel: true,
      },

      xAxis: {
        type: 'value',
        show: false,
      },
      yAxis: {
        type: 'category',
        data: ['Situação'],
      },

      series: seriesComPercentual,
    };
  }
  private initChartTelefonia(itens: DadosGrafico[]) {
    const data = itens.map((item) => ({
      value: item.quantidade,
    }));

    const somaDataTelefonia = data.reduce((acc, item) => acc + item.value, 0);
    const dataComPercentual = data.map((item, index) => ({
      value: item.value,
      itemStyle: {
        color: this.getChartColors(index),
      },
      percentual: ((item.value / somaDataTelefonia) * 100).toFixed(1),
    }));

    this.flagsTelefoniaOptions = {
      tooltip: {
        trigger: 'item',
        formatter: (params: any) => {
          return `<b>Quantidade:</b> ${StringUtil.formatarNumeroMilharesCentenas(
            params.value
          )}`;
        },
      },
      label: {
        show: true,
        color: '#191104',
        textBorderWidth: 0,
        textBorderColor: 'transparent',
        formatter: (params: any) => {
          const percentual = Number(
            dataComPercentual[params.dataIndex].percentual
          );
          if (!isNaN(percentual)) {
            return `${percentual}%`;
          } else {
            return '0%';
          }
        },
        position: ['50%', '40%'],
      },
      grid: {
        top: '5%',
        left: '1%',
        right: '5%',
        bottom: '5%',
        containLabel: true,
      },
      xAxis: {
        type: 'value',
        boundaryGap: [0, 0.01],
        axisLabel: { show: false },
        splitLine: { show: false },
      },
      yAxis: {
        type: 'category',
        data: ['Badphone', 'Assinante', 'Hot', 'WhatsApp', 'Procon'],
      },
      series: [
        {
          type: 'bar',
          barWidth: 35,
          data: dataComPercentual,
        },
      ],
      plugins: {
        legend: {
          display: true,
          labels: {
            color: 'black',
            textBorderWidth: 0,
            textBorderColor: 'transparent',
          },
        },
      },
    };
  }

  private initChartPersonasPorGeracao(itens: DadosGrafico[]) {
    const data = itens.map((item) => ({
      value: item.quantidade,
      name: item.descricao,
    }));

    const totalGeracoes = data.reduce((acc, item) => acc + item.value, 0);
    const dataComCores = data.map((item, index) => ({
      ...item,
      itemStyle: {
        color: this.getChartColors(index),
      },
      percentual: ((item.value / totalGeracoes) * 100).toFixed(1),
    }));

    this.personasPorGeracaoOptions = {
      tooltip: {
        formatter: (params: any) => {
          return `<b>Quantidade:</b> ${StringUtil.formatarNumeroMilharesCentenas(
            params.data.value
          )}`;
        },
      },
      legend: {
        show: true,
        orient: 'horizontal',
      },
      series: [
        {
          name: 'Persona de geração',
          type: 'pie',
          radius: [50, 90],
          center: ['50%', '63%'],
          roseType: 'area',
          itemStyle: {
            borderRadius: 8,
          },
          label: {
            show: true,
            formatter: (params: any) => {
              return `${params.percent.toFixed(1)}%`;
            },
          },
          data: dataComCores,
        },
      ],
    };
  }

  private initChartNuvemPalavras(itens: DadosGrafico[]) {
    var data = itens.map((item) => ({
      name: item.descricao,
      value: item.quantidade,
    }));

    this.nuvemPalavrasOptions = {
      tooltip: {},
      series: [
        {
          type: 'wordCloud' as any,
          gridSize: 12,
          sizeRange: [16, 70],
          rotationRange: [0, 0],
          rotationStep: 0,
          left: 0,
          top: 0,
          right: null,
          bottom: null,
          width: '100%',
          height: '100%',
          textStyle: {
            fontFamily: 'sans-serif',
            fontWeight: 'bold',
            color: (params: any) => {
              const values = data.map((item: any) => item.value);
              const maxValue = Math.max(...values);
              const minOpacity = 0.1;
              const maxOpacity = 1.0;

              const opacity =
                minOpacity +
                (params.data.value / maxValue) * (maxOpacity - minOpacity);
              return `rgba(58, 125, 232, ${opacity})`;
            },
          },
          data: data,
        },
      ] as any,
    };
  }

  private initChartScore(itens: DadosGrafico[]) {
    const isSmallScreen = window.innerWidth <= 1408;

    const data = itens.map((item) => ({
      value: item.quantidade,
      name: item.descricao,
    }));

    this.scoreOptions = {
      tooltip: {
        trigger: 'item',
        formatter: (params: any) => {
          return `<b>Quantidade:</b> ${StringUtil.formatarNumeroMilharesCentenas(
            params.value
          )}`;
        },
      },
      label: {
        show: true,
        position: 'inside',
        formatter: (params: any) => {
          return `${params.percent.toFixed(1)}%`;
        },
      },
      legend: {
        show: true,
        orient: 'horizontal',
        type: isSmallScreen ? 'scroll' : 'plain',
      },
      series: [
        {
          name: 'Score',
          type: 'pie',
          radius: '70%',
          center: ['50%', '62%'],
          data: data,
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)',
            },
          },
        },
      ],
    };
  }

  private initChartFaixaSalarial(itens: DadosGrafico[]) {
    const data = itens.map((item) => ({
      name: item.descricao,
      value: item.quantidade,
    }));

    const totalPopulacao = data.reduce((total, item) => total + item.value, 0);

    this.faixaSalarialOptions = {
      tooltip: {
        trigger: 'item',
        formatter: (params: any) => {
          return `<b>${params.data.name}</b><br>
                  <b>Quantidade:</b> ${StringUtil.formatarNumeroMilharesCentenas(
                    params.data.value
                  )}<br>
                  <b>Percentual:</b> ${(
                    (params.data.value / totalPopulacao) *
                    100
                  ).toFixed(1)}%`;
        },
      },
      label: {
        formatter: (params: any) => {
          const label = params.data.name;
          const percentual = (
            (params.data.value / totalPopulacao) *
            100
          ).toFixed(1);
          return `${label}:\n ${percentual}%`;
        },
      },
      series: [
        {
          type: 'treemap',
          data: data,
        },
      ],
    };
  }

  private initChartPersonaDigital(itens: DadosGrafico[]) {
    const data = itens.map((item) => ({
      value: item.quantidade,
      name: item.descricao,
    }));

    this.personaDigitalOptions = {
      tooltip: {
        trigger: 'item',
        formatter: (params: any) => {
          return `<b>Quantidade:</b> ${StringUtil.formatarNumeroMilharesCentenas(
            params.value
          )}`;
        },
      },
      label: {
        show: true,
        position: 'inside',
        formatter: (params: any) => {
          return `${params.percent.toFixed(1)}%`;
        },
      },
      legend: {
        show: true,
        orient: 'horizontal',
      },
      series: [
        {
          name: 'Persona Digital',
          type: 'pie',
          radius: '70%',
          center: ['50%', '60%'],
          data: data,
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)',
            },
          },
        },
      ],
    };
  }

  private recriarGraficos(): void {
    if (!this.filtrosSegmentacao || !this.filtrosSegmentacao.tiposRetorno) {
      return;
    }

    if (this.filtrosSegmentacao.tiposRetorno.includes(TipoGrafico.Score)) {
      this.initChartScore(
        this.getDetalhes(TipoGrafico.Score, this.dadosSegmentacao)
      );
    }

    if (
      this.filtrosSegmentacao.tiposRetorno.includes(TipoGrafico.PersonaGeracao)
    ) {
      this.initChartPersonasPorGeracao(
        this.getDetalhes(TipoGrafico.PersonaGeracao, this.dadosSegmentacao)
      );
    }

    if (
      this.filtrosSegmentacao.tiposRetorno.includes(TipoGrafico.FlagsTelefonia)
    ) {
      this.initChartTelefonia(
        this.getDetalhes(TipoGrafico.FlagsTelefonia, this.dadosSegmentacao)
      );
    }

    if (
      this.filtrosSegmentacao.tiposRetorno.includes(TipoGrafico.FaixaSalarial)
    ) {
      this.initChartFaixaSalarial(
        this.getDetalhes(TipoGrafico.FaixaSalarial, this.dadosSegmentacao)
      );
    }

    if (
      this.filtrosSegmentacao.tiposRetorno.includes(TipoGrafico.PersonaDigital)
    ) {
      this.initChartPersonaDigital(
        this.getDetalhes(TipoGrafico.PersonaDigital, this.dadosSegmentacao)
      );
    }

    if (this.filtrosSegmentacao.tiposRetorno.includes(TipoGrafico.Palavras)) {
      this.initChartNuvemPalavras(
        this.getDetalhes(TipoGrafico.Palavras, this.dadosSegmentacao)
      );
    }

    if (
      this.filtrosSegmentacao.tiposRetorno.includes(TipoGrafico.SituacaoCPF)
    ) {
      this.initChartSituacaoDocumentos(
        this.getDetalhes(TipoGrafico.SituacaoCPF, this.dadosSegmentacao)
      );
    }
  }

  async limparFiltro(): Promise<void> {
    this.filtroSegmentacaoService.resetarFiltro();
    this.filtrosSegmentacao = this.filtroSegmentacaoService.obterFiltroAtual();

    this.optUfsSelecionadas = [];
    this.optCidadesSelecionadas = [];
    this.optTipoContato = [];

    if (this.optUfs.length > 0) {
      this.optUfs = this.optUfs.map((uf) => ({
        ...uf,
        checked: false,
      }));
    }

    if (
      this.filtrosSegmentacao?.tiposRetorno?.includes(TipoGrafico.SituacaoCPF)
    ) {
      this.initChartSituacaoDocumentos(
        this.getDetalhes(TipoGrafico.SituacaoCPF, this.dadosSegmentacao)
      );
    }
    this.cdr.detectChanges();
    await this.buscarSegmentacao();
  }

  async verificarPreGravacao(): Promise<void> {
    try {
      this.toastr.info('Verificando listas existentes...');
      this.verificandoListaExistente = true;
      this.preGravacaoResponse = undefined;

      const response = await this.listasService.preGravacao({
        filtro: this.filtrosSegmentacao,
        nomeLista: '',
        qtdeExtracao: this.contadores.oportunidadesNumber,
        continuarExtracao: this.continuarExtracaoContatos,
      });

      this.preGravacaoResponse = response;
      this.qtdRegistrosDisponiveis =
        this.contadores.oportunidadesNumber -
        (this.preGravacaoResponse.quantidade || 0);

      if (response.exitemListas) {
        const modalElement = document.getElementById(
          'modalAvisoListasExistentes'
        );
        if (modalElement) {
          const modalAviso = new bootstrap.Modal(modalElement);
          modalAviso.show();
        }
      } else {
        this.abrirModalNovaLista();
      }
    } catch (error) {
      console.error('Erro ao verificar pré-gravação:', error);
      this.toastr.error('Erro ao verificar listas existentes.', 'Erro');
    } finally {
      this.verificandoListaExistente = false;
      this.cdr.detectChanges();
    }
  }

  private abrirModalNovaLista(): void {
    const modalElement = document.getElementById('modalGerarListaContatos');
    if (modalElement) {
      const modalNovaLista = new bootstrap.Modal(modalElement);
      modalNovaLista.show();
    }
  }
  continuarExtracao(): void {
    const modalAvisoElement = document.getElementById(
      'modalAvisoListasExistentes'
    );
    if (modalAvisoElement) {
      const modalAviso = bootstrap.Modal.getInstance(modalAvisoElement);
      modalAviso?.hide();
    }

    if (this.preGravacaoResponse && this.preGravacaoResponse.quantidade) {
      this.qtdRegistrosDisponiveis =
        this.contadores.oportunidadesNumber -
        this.preGravacaoResponse.quantidade;
    }

    this.continuarExtracaoContatos = true;

    this.abrirModalNovaLista();
  }

  reiniciarExtracao(): void {
    const modalAvisoElement = document.getElementById(
      'modalAvisoListasExistentes'
    );
    if (modalAvisoElement) {
      const modalAviso = bootstrap.Modal.getInstance(modalAvisoElement);
      modalAviso?.hide();
    }

    this.qtdRegistrosDisponiveis = this.contadores.oportunidadesNumber;

    this.continuarExtracaoContatos = false;

    this.abrirModalNovaLista();
  }

  mostrarBotaoLimpar(): boolean {
    const filtroPadrao = JSON.stringify(
      this.filtroSegmentacaoService.getFiltroInicial()
    );
    const filtroSelecionado = JSON.stringify(this.filtrosSegmentacao);
    return filtroPadrao !== filtroSelecionado;
  }

  validarCampoIdade(event: Event, campo: 'de' | 'ate'): void {
    const inputElement = event.target as HTMLInputElement;
    let valorAtual = inputElement.value;

    valorAtual = valorAtual.replace(/[^0-9]/g, '');

    inputElement.value = valorAtual;

    if (valorAtual === '') {
      this.filtroIdade[campo] = undefined;
    } else {
      const valorNumerico = parseInt(valorAtual);
      this.filtroIdade[campo] = valorNumerico;
    }
  }
  
  validarBotaoOkIdades(): boolean {
	  const de = this.filtroIdade['de'] ? String(this.filtroIdade['de']).trim() : '';
	  const ate = this.filtroIdade['ate'] ? String(this.filtroIdade['ate']).trim() : '';

    if (!de && !ate) return true;

    if (de && ate) return true;

    return false;
  }  

  validarLimiteIdade(event: Event, campo: 'de' | 'ate'): void {
    const inputElement = event.target as HTMLInputElement;
    let valorAtual = inputElement.value;

    if (valorAtual === '') {
      this.filtroIdade[campo] = undefined;
      return;
    }

    const valorNumerico = parseInt(valorAtual);

    if (valorNumerico > 120) {
      inputElement.value = '120';
      this.filtroIdade[campo] = 120;
    } else if (valorNumerico < 18) {
      inputElement.value = '18';
      this.filtroIdade[campo] = 18;
    }
  }

  SalvarCamposIdade() : void {
    const camposValidos = this.validarBotaoOkIdades();
    const valoresValidos = this.ValidarValorIdade(this.filtroIdade.de, this.filtroIdade.ate);

    if(!valoresValidos) {
      return;
    }

    if (camposValidos) {
      this.atualizarSegmentacao([]);
      this.fecharPainelLateral();
    }
    else {
      this.toastr.warning('Atenção! Preencher todos os campos ou deixar ambos vazios');
    }
  }

  limparCamposIdade() : void {
    this.filtroIdade = { de: undefined, ate: undefined };
  }

  ValidarValorIdade(idadeMinima: number | undefined, idadeMaxima: number | undefined) : boolean {
    if (idadeMinima !== undefined && idadeMaxima !== undefined && idadeMinima > idadeMaxima) {
      this.toastr.warning('A idade mínima não pode ser maior que a idade máxima.');
      return false;
    }
    
    return true;
  }
}
